import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { AllureYearlyPlanActionTypes } from "./AllureYearlyPlan.type";
import { formatQuery } from "../Utils";

export function* fetchAllAllureYearlyPlans(action: any): any {
    try {
        const response = yield axios.get(`${API_BASE_URI}/allure-yearly-plan?${formatQuery(action)}`);
        yield put({
            type: AllureYearlyPlanActionTypes.FETCH_ALL_ALLURE_YEARLY_PLAN_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: AllureYearlyPlanActionTypes.FETCH_ALL_ALLURE_YEARLY_PLAN_FAILURE,
            payload: error,
        });
    }
}

export function* fetchOneAllureYearlyPlans(action: any): any {
    try {
        const response = yield axios.get(
            `${API_BASE_URI}/allure-yearly-plan/${action.payload}`
        );
        yield put({
            type: AllureYearlyPlanActionTypes.FETCH_ONE_ALLURE_YEARLY_PLAN_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: AllureYearlyPlanActionTypes.FETCH_ONE_ALLURE_YEARLY_PLAN_FAILURE,
            payload: error,
        });
    }
}

export function* watcherFetchAllAllureYearlyPlans() {
    yield takeLatest(AllureYearlyPlanActionTypes.FETCH_ALL_ALLURE_YEARLY_PLAN, fetchAllAllureYearlyPlans);
}

export function* watcherFetchOneAllureYearlyPlans() {
    yield takeLatest(AllureYearlyPlanActionTypes.FETCH_ONE_ALLURE_YEARLY_PLAN, fetchOneAllureYearlyPlans);
}
